import { CreateBankPaymentRequest } from '@screens/PlacingOrder';
import { OrderBankInfoType } from '@shared/types/order';
import FetchData from '@shared/utils/fetchData/fetchData';

export const createOrderBankPayment = async (params: CreateBankPaymentRequest) => {
  return await FetchData.post<OrderBankInfoType>('orders/raif', {
    body: JSON.stringify(params)
  });
};
